import { SEARCH_MIN_QUERY_LENGTH } from '@lib/shared';

import { ListingFeature, SaleType, type ListingFiltersDto } from '~/apiClient';
import type { PlatformSellingMethod } from '~/types/sale.type';

/** The filters of the SLP in the vocabulary of a saved search: what the listing shows, its state and sorting aside. */
export const getSavedSearchFilters = (params: UseSlpParamsReturn<PlatformSellingMethod>): ListingFiltersDto => {
    const q = params.q.value.trim();

    return {
        brandUrlKeys: params.brandUrlKeys.value,
        ...(params.selectedModelUrlKey.value && { modelUrlKey: params.selectedModelUrlKey.value }),
        platformClass: params.platformBusClass.value,
        busType: params.busType.value,
        fuel: params.fuel.value,
        euroNorm: params.euroNorm.value,
        gearboxType: params.gearboxType.value,
        deckType: params.deckType.value,
        wheelchairRamp: params.wheelchairRamp.value,
        vehicleCondition: params.vehicleCondition.value,
        cruiseControl: params.cruiseControl.value,
        tachograph: params.tachograph.value,
        seatUpholstery: params.seatUpholstery.value,
        chargingType: params.chargingType.value,
        enginePosition: params.enginePosition.value,
        retarder: params.retarder.value,
        useType: params.useType.value,
        engineBrand: params.engineBrand.value,
        gearboxBrand: params.gearboxBrand.value,
        axles: params.axles.value,
        wheels: params.wheels.value,
        wheelsSizeAxle1: params.wheelsSizeAxle1.value,
        wheelsSizeAxle2: params.wheelsSizeAxle2.value,
        wheelsSizeAxle3: params.wheelsSizeAxle3.value,
        doors: params.doors.value,
        monitors: params.monitors.value,
        countryCodes: params.countryCodes.value,
        registrationDocumentCountry: params.registrationDocumentCountry.value,
        features: Object.values(ListingFeature).filter(feature => params[feature].value),
        saleType: params.saleType.value.map(saleBundleType => SaleType[saleBundleType]),
        ...Object.fromEntries(
            SLP_RANGE_FILTER_KEYS.flatMap(key => [
                [`${key}From`, params[`${key}From`].value],
                [`${key}To`, params[`${key}To`].value],
            ]).filter(([, value]) => value !== undefined)
        ),
        ...(q.length >= SEARCH_MIN_QUERY_LENGTH && { q }),
    };
};
